import { render, staticRenderFns } from "./BulkDriverView.vue?vue&type=template&id=9545793c&scoped=true&"
import script from "./BulkDriverView.vue?vue&type=script&lang=js&"
export * from "./BulkDriverView.vue?vue&type=script&lang=js&"
import style0 from "./BulkDriverView.vue?vue&type=style&index=0&id=9545793c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9545793c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VBtn,VCard})
